import { css } from '@sitebase/emotion';
import { rawButton, sizeNormal, colorMonochromeWhite, colorAccent500, fontFamilyDefault, radiusDefaultSize } from '../settings';

var tooltipMinWidth = '100px';
var tooltipMaxWidth = '180px';
var tooltipMinHeight = '28px';
var tooltipMargin = '10px';
var textBoxMaxWidth = '160px';
var textBoxMaxWidthNarrower = '144px';
var textBoxMinWidth = '92px';
var arrowWidth = '4px';
var arrowOffset = '16px';
var closeButtonSize = '28px';
var fontSizeTooltip = '11px';
var lineHeightTooltip = '12px';

export var tooltip = /*#__PURE__*/css('display:inline-block;position:relative;');

export var tooltipTrigger = /*#__PURE__*/css('display:flex;');
export var tooltipCloseButton = /*#__PURE__*/css(rawButton, ';align-items:center;cursor:pointer;box-sizing:border-box !important;color:', colorMonochromeWhite, ';display:inline-flex;height:', closeButtonSize, ';justify-content:center;outline-offset:-2px;width:', closeButtonSize, ';');
export var tooltipContent = /*#__PURE__*/css('box-sizing:border-box;max-width:calc(', textBoxMaxWidth, ' + 2 * ', sizeNormal, ');min-height:', tooltipMinHeight, ';min-width:calc(', textBoxMinWidth, ' + 2 * ', sizeNormal, ');padding:', sizeNormal, ';text-align:left;vertical-align:middle;');
export var tooltipContentNarrower = /*#__PURE__*/css('max-width:calc(', textBoxMaxWidthNarrower, ' + ', sizeNormal, ');min-width:calc(', textBoxMaxWidthNarrower, ' + ', sizeNormal, ');padding-right:0;');
export var tooltipContentFlexible = /*#__PURE__*/css('max-width:100vw;');
export var tooltipContentWrapper = /*#__PURE__*/css('display:table;');

export var tooltipTipWrapperTopLeft = /*#__PURE__*/css('/*! tooltipTipWrapperTopLeft */');

export var tooltipTipWrapperTop = /*#__PURE__*/css('/*! tooltipTipWrapperTop */');

export var tooltipTipWrapperTopRight = /*#__PURE__*/css('/*! tooltipTipWrapperTopRight */');

export var tooltipTipWrapperRight = /*#__PURE__*/css('/*! tooltipTipWrapperRight */');

export var tooltipTipWrapperBottomRight = /*#__PURE__*/css('/*! tooltipTipWrapperBottomRight */');

export var tooltipTipWrapperBottom = /*#__PURE__*/css('/*! tooltipTipWrapperBottom */');

export var tooltipTipWrapperBottomLeft = /*#__PURE__*/css('/*! tooltipTipWrapperBottomLeft */');

export var tooltipTipWrapperLeft = /*#__PURE__*/css('/*! tooltipTipWrapperLeft */');

var _ref = 'height:0;left:50%;margin-left:calc(-';
var _ref2 = ' / 2);overflow:visible;position:absolute;top:50%;width:';
var _ref3 = ';&.';
var _ref4 = '{left:0;margin-left:0;top:0;}&.';
var _ref5 = '{top:0;}&.';
var _ref6 = '{left:auto;right:0;top:0;}&.';
var _ref7 = '{left:auto;right:0;}&.';
var _ref8 = '{left:auto;right:0;top:100%;}&.';
var _ref9 = '{top:100%;}&.';
var _ref10 = '{left:0;margin-left:0;top:100%;}&.';
var _ref11 = '{left:0;margin-left:0;}';
export var tooltipTipWrapper = function tooltipTipWrapper(flexible) {
  return (/*#__PURE__*/css(_ref, flexible ? '100vw' : tooltipMaxWidth, _ref2, flexible ? '100vw' : tooltipMaxWidth, _ref3, tooltipTipWrapperTopLeft, _ref4, tooltipTipWrapperTop, _ref5, tooltipTipWrapperTopRight, _ref6, tooltipTipWrapperRight, _ref7, tooltipTipWrapperBottomRight, _ref8, tooltipTipWrapperBottom, _ref9, tooltipTipWrapperBottomLeft, _ref10, tooltipTipWrapperLeft, _ref11)
  );
};

export var tooltipTipTopLeft = /*#__PURE__*/css('/*! tooltipTipWrapperTopLeft */');

export var tooltipTipTop = /*#__PURE__*/css('/*! tooltipTipTop */');

export var tooltipTipTopRight = /*#__PURE__*/css('/*! tooltipTipTopRight */');

export var tooltipTipRight = /*#__PURE__*/css('/*! tooltipTipRight */');

export var tooltipTipBottomRight = /*#__PURE__*/css('/*! tooltipTipBottomRight */');

export var tooltipTipBottom = /*#__PURE__*/css('/*! tooltipTipBottom */');

export var tooltipTipBottomLeft = /*#__PURE__*/css('/*! tooltipTipBottomLeft */');

export var tooltipTipLeft = /*#__PURE__*/css('/*! tooltipTipLeft */');

var _ref12 = 'align-items:center;background-color:';
var _ref13 = ';border-color:';
var _ref14 = ';border-radius:';
var _ref15 = ';box-sizing:border-box !important;color:';
var _ref16 = ';display:flex;font-family:';
var _ref17 = ';font-size:';
var _ref18 = ';line-height:';
var _ref19 = ';max-width:';
var _ref20 = ';min-height:';
var _ref21 = ';min-width:';
var _ref22 = ';position:absolute;z-index:10;&::after{border:';
var _ref23 = ' solid transparent;content:\'\';position:absolute;width:0;}&.';
var _ref24 = '{bottom:calc(100% + ';
var _ref25 = ');left:0;&::after{border-top-color:inherit;left:';
var _ref26 = ';margin-left:-';
var _ref27 = ';top:100%;}}&.';
var _ref28 = '{bottom:calc(100% + ';
var _ref29 = ');left:50%;margin-right:-50%;transform:translateX(-50%);&::after{border-top-color:inherit;left:50%;margin-left:-';
var _ref30 = ';top:100%;}}&.';
var _ref31 = '{bottom:calc(100% + ';
var _ref32 = ');right:0;&::after{border-top-color:inherit;margin-left:-';
var _ref33 = ';right:';
var _ref34 = ';top:100%;}}&.';
var _ref35 = '{right:-';
var _ref36 = ';top:50%;transform:translate(100%,-50%);&::after{border-right-color:inherit;right:100%;top:50%;transform:translateY(-50%);}}&.';
var _ref37 = '{right:0;top:calc(100% + ';
var _ref38 = ');&::after{border-bottom-color:inherit;bottom:100%;margin-left:calc(-';
var _ref39 = ' / 2);right:';
var _ref40 = ';}}&.';
var _ref41 = '{left:50%;margin-right:-50%;top:calc(100% + ';
var _ref42 = ');transform:translateX(-50%);&::after{border-bottom-color:inherit;bottom:100%;left:50%;margin-left:calc(-';
var _ref43 = ' / 2);}}&.';
var _ref44 = '{left:0;top:calc(100% + ';
var _ref45 = ');&::after{border-bottom-color:inherit;bottom:100%;left:';
var _ref46 = ';margin-left:calc(-';
var _ref47 = ' / 2);}}&.';
var _ref48 = '{left:-';
var _ref49 = ';top:50%;transform:translate(-100%,-50%);&::after{border-left-color:inherit;left:100%;top:50%;transform:translateY(-50%);}}';
export var tooltipTip = function tooltipTip(flexible) {
  return (/*#__PURE__*/css(_ref12, colorAccent500, _ref13, colorAccent500, _ref14, radiusDefaultSize, _ref15, colorMonochromeWhite, _ref16, fontFamilyDefault, _ref17, fontSizeTooltip, _ref18, lineHeightTooltip, _ref19, flexible ? '100vw' : tooltipMaxWidth, _ref20, tooltipMinHeight, _ref21, tooltipMinWidth, _ref22, arrowWidth, _ref23, tooltipTipTopLeft, _ref24, tooltipMargin, _ref25, arrowOffset, _ref26, arrowWidth, _ref27, tooltipTipTop, _ref28, tooltipMargin, _ref29, arrowWidth, _ref30, tooltipTipTopRight, _ref31, tooltipMargin, _ref32, arrowWidth, _ref33, arrowOffset, _ref34, tooltipTipRight, _ref35, tooltipMargin, _ref36, tooltipTipBottomRight, _ref37, tooltipMargin, _ref38, tooltipMargin, _ref39, arrowOffset, _ref40, tooltipTipBottom, _ref41, tooltipMargin, _ref42, tooltipMargin, _ref43, tooltipTipBottomLeft, _ref44, tooltipMargin, _ref45, arrowOffset, _ref46, tooltipMargin, _ref47, tooltipTipLeft, _ref48, tooltipMargin, _ref49)
  );
};